export default function (context, index) {
    context.commit('current_setting', index);
}